import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const store = new Vuex.Store({
    // 1. state
    state:{
        userUnformation:{},  //用户信息
        provinceData:[], // 省数组
        socketType:false,//长链接是否建立成功
        socketData:{},//长连接数据
        socketTh:{},//太行长连接
        client:{},//声网数据
        oldPath:'',//老路由
        urlOnlyArr:[],
        baseURL:'https://dep.xinchao.com/dep/',//访问路径
        // baseURL:'https://t.tdashi.xinchao.com/dep/',//访问路径
        buttonCtrl:[],//权限
        loddingMsg:'',//登陆msg长连接
        },



    // // 2. getters
    getters:{
        // 参数列表state指的是state数据
        getUserUnformation(state){
            return state.userUnformation;
        },
        getProvinceData(state){
            return state.provinceData;
        },
        getSocketType(state){
            return state.socketType;
        },
        getSocketData(state){ //获取长连接数据
            console.log('state='+state.socketData)
            return state.socketData
        },
         getSocketTh(state){ //获取长连接数据
            console.log('state='+state.getSocketTh)
            return state.socketTh
        },
        getClient(state){  //获取声网数据
            return state.client
        },
        getBaseUrl(state){  //获取声网数据
            return state.baseURL
        },
        getUrlOnlyArr(state){  //获取声网数据
            return state.urlOnlyArr
        },
        getLoddingMsg(state){  //获取声网数据
            console.log('loddingMsg='+state.loddingMsg)
            return state.loddingMsg
        },
    },
    // 3. actions
    // 通常跟api接口打交道
    actions:{
        // 设置城市信息
        // 参数列表：{commit, state}
        // state指的是state数据
        // commit调用mutations的方法 
        // name就是调用此方法时要传的参数
        setUserUnformationName({commit,state}, object){
            // 跟后台打交道
            // 调用mutaions里面的方法
            commit("setUserUnformation", object);
        },
        setProvinceData({commit,state}, object){
            // 跟后台打交道
            // 调用mutaions里面的方法
            commit("setProvinceData", object);
        },
        setSocketType({commit,state}, object){
            commit("setSocketType", object);
        },
        setSocketData({commit,state}, object){
            commit("setSocketData", object);
        },
        setSocketTh({commit,state}, object){
            commit("setSocketTh", object);
        },
        setClient({commit,state}, object){
            commit("setClient", object);
        },
        setBaseUrl({commit,state}, object){
            commit("setBaseUrl", object);
        },
        setLoddingMsg({commit,state}, object){
            console.log('setLoddingMsg='+object)
            commit("setLoddingMsg", object);
        },
        setUrlOnlyArr({commit,state}, object){
            commit("setUrlOnlyArr", object);
        },
    },
    // 4. mutations
    mutations:{
        // state指的是state的数据
        // name传递过来的数据
        setUserUnformation(state, object){
            state.userUnformation = object;//将传参设置给state的city
        },
        setProvinceData(state, object){
            state.provinceData = object;
        },
        setSocketType(state, object){
            state.socketType = object;
        },
        setSocketData(state, object){
            state.socketData = object;
            console.log('socketData='+object)
        },
         setSocketTh(state, object){
            state.socketTh = object;
            console.log('socketTh='+object)
        },
        setClient(state, object){
            state.client = object;
        },
        setOldPath(state,path){
            state.oldPath = path;
        },
        // 菜单权限
        setUrlOnlyArr(state,path){
            state.urlOnlyArr = path;
        },
        setLoddingMsg(state,path){
            console.log('loddingMsg='+path)
            state.loddingMsg = path;
        },
        // setbaseURL(state,path){
        //     state.baseURL = path;
        // }
        // 切换权限
        getButton(state,buttonCtrl){
            "use strict";
                state.buttonCtrl = buttonCtrl;
            },
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js